import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "design-react-kit";

const ModalComponent = (props) => {
  const denyFun = () => {
    props.toggleModal(!props.isOpen);
    if (props.functionDeny) props.functionDeny();
  };

  return (
    <div>
      <Modal
        isOpen={props.isOpen}
        toggle={() => props.toggleModal(!props.isOpen)}
        size={props.size ? props.size : "lg"}
        labelledBy={"Modale" + props.id !== undefined && props.id}
        className={props.modalCenter && "modal-dialog-centered"}
      >
        {props.buttonTopDeny && (
          <div className="cmp-modal__header modal-header pb-0">
            <button
              className="btn-close btn-close-sm"
              aria-label="Chiudi finestra modale"
              onClick={() => props.toggleModal(!props.isOpen)}
            ></button>
          </div>
        )}
        <ModalHeader
          style={{ fontSize: "1.1rem" }}
          id={"Modale" + props.id !== undefined && props.id}
        >
          {props.header}
        </ModalHeader>
        <ModalBody>{props.body}</ModalBody>
        <ModalFooter>
          {props.buttonConfirm && (
            <Button
              color="primary text-white text-center"
              onClick={() => props.function()}
            >
              {props.buttonConfirm}
            </Button>
          )}
          {props.buttonDeny && (
            <Button
              color="danger text-white text-center"
              onClick={() => denyFun()}
            >
              {props.buttonDeny}
            </Button>
          )}
        </ModalFooter>
      </Modal>
    </div>
  );
};
export default ModalComponent;
